import { useEffect } from 'react';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const GTM_ID = 'AW-18020137835';

const GoogleTagManager = () => {
  useEffect(() => {
    // Check if script already exists to avoid duplicate injection
    if (!document.getElementById('gtm-script')) {
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${GTM_ID}`;
      script1.id = 'gtm-script';
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GTM_ID}');
      `;
      document.head.appendChild(script2);
    }
  }, []);

  return null;
};

export default GoogleTagManager;
